import * as React from 'react';
import { Box, Grid, styled } from '@mui/material';
import Image from 'assets/images/LoginSignUpImage.jpg';

export default function SignUpLoginContainer({ children }: { children: React.ReactNode }) {
    return (
        <Container container>
            {children}
            <Grid item sm={12} md={6} sx={{ zIndex: -1, height: '100vh' }}>
                <Box
                    component="img"
                    src={Image}
                    alt="Customer testimonial"
                    sx={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        objectPosition: 'center center',
                    }}
                    display={{ md: 'none', lg: 'block' }}
                />
            </Grid>
        </Container>
    );
}

const Container = styled(Grid)({
    height: '95vh',
    overflow: 'hidden',
});
